"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.verifyTurnstileToken = void 0;
const ReactCloudflareTurnstile_1 = __importDefault(require("./ReactCloudflareTurnstile"));
class VerifyTurnstileTokenError extends Error {
    constructor(message, verifyTurnstileTokenOutcome) {
        super(message);
        this.verifyTurnstileTokenOutcome = verifyTurnstileTokenOutcome;
    }
}
const verifyTurnstileToken = async ({ turnstileSecretKey, token, }) => {
    return new Promise(async (resolve, reject) => {
        try {
            let verificationFormData = new FormData();
            verificationFormData.append("secret", turnstileSecretKey);
            verificationFormData.append("response", token);
            const url = "https://challenges.cloudflare.com/turnstile/v0/siteverify";
            const verifyTurnstileTokenResponse = await fetch(url, {
                body: verificationFormData,
                method: "POST",
            });
            const verifyTurnstileTokenOutcome = await verifyTurnstileTokenResponse.json();
            if (!verifyTurnstileTokenOutcome.success) {
                throw new VerifyTurnstileTokenError("Turnstile Token Verification Failed", verifyTurnstileTokenOutcome);
            }
            resolve(verifyTurnstileTokenOutcome);
        }
        catch (error) {
            reject(error);
        }
    });
};
exports.verifyTurnstileToken = verifyTurnstileToken;
exports.default = ReactCloudflareTurnstile_1.default;
//# sourceMappingURL=index.js.map